import ChatAssistantPage from '@/components/chatAssistant/chatAssistantPage';

const AssistantPage = () => {
  return <ChatAssistantPage />;
};

export default AssistantPage;
